const isBrowser = typeof window !== 'undefined'

export const CONFIRM_MARKER_PREFIX = 'confirmCode:'
export const CONFIRM_EMAIL_STORAGE_KEY = 'confirmEmailAddress'
export const CONFIRM_DOMAIN_STORAGE_KEY = 'confirmEmailDomainStatus'

export const readStoredConfirmEmail = () => {
  if (!isBrowser) return ''
  try {
    return window.sessionStorage.getItem(CONFIRM_EMAIL_STORAGE_KEY) || ''
  } catch {
    return ''
  }
}

export const writeStoredConfirmEmail = (value) => {
  if (!isBrowser) return
  const nextValue = typeof value === 'string' ? value.trim() : ''
  try {
    if (nextValue) window.sessionStorage.setItem(CONFIRM_EMAIL_STORAGE_KEY, nextValue)
    else window.sessionStorage.removeItem(CONFIRM_EMAIL_STORAGE_KEY)
  } catch {
    /* no-op */
  }
}

export const readStoredConfirmDomain = () => {
  if (!isBrowser) return ''
  try {
    const value = window.sessionStorage.getItem(CONFIRM_DOMAIN_STORAGE_KEY)
    return value === 'valid' || value === 'invalid' ? value : ''
  } catch {
    return ''
  }
}

export const writeStoredConfirmDomain = (value) => {
  if (!isBrowser) return
  const nextValue = value === 'valid' || value === 'invalid' ? value : ''
  try {
    if (nextValue) window.sessionStorage.setItem(CONFIRM_DOMAIN_STORAGE_KEY, nextValue)
    else window.sessionStorage.removeItem(CONFIRM_DOMAIN_STORAGE_KEY)
  } catch {
    /* no-op */
  }
}

export const clearStoredConfirmEmailState = () => {
  if (!isBrowser) return

  try {
    window.sessionStorage.removeItem(CONFIRM_EMAIL_STORAGE_KEY)
    window.sessionStorage.removeItem(CONFIRM_DOMAIN_STORAGE_KEY)
  } catch {
    /* no-op */
  }

  try {
    const keys = []
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i)
      if (key?.startsWith(CONFIRM_MARKER_PREFIX)) keys.push(key)
    }
    keys.forEach((key) => window.localStorage.removeItem(key))
  } catch {
    /* no-op */
  }
}
